import Link from "next/link";
import * as React from "react";
import { generatePath } from "react-router";

import { MenuItem } from "@graphql/gqlTypes/MenuItem";
import { paths } from "@paths";

interface NavLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  item: MenuItem;
}
export const NavLink: React.FC<NavLinkProps> = ({ item, ...props }) => {
  const { name, url, category, collection, page, link } = item;
  const getlink = (linkUrl: string) => (
    <Link passHref href={linkUrl}>
      <a {...props}>{name}</a>
    </Link>
  );

  // For external links
  if (url) {
    return (
      <a href={url} {...props}>
        {name}
      </a>
    );
  }

  // For internal links
  if (link) {
    return getlink(link);
  }
  if (category) {
    return getlink(generatePath(paths.category, { slug: category.slug }));
  }
  if (collection) {
    return getlink(generatePath(paths.collection, { slug: collection.slug }));
  }
  if (page) {
    return getlink(generatePath(paths.page, { slug: page.slug }));
  }

  return <span {...props}>{name}</span>;
};
